import $wOb1a$intlcolorarAEmjs from "../intl/color/ar-AE.mjs";
import $wOb1a$intlcolorbgBGmjs from "../intl/color/bg-BG.mjs";
import $wOb1a$intlcolorcsCZmjs from "../intl/color/cs-CZ.mjs";
import $wOb1a$intlcolordaDKmjs from "../intl/color/da-DK.mjs";
import $wOb1a$intlcolordeDEmjs from "../intl/color/de-DE.mjs";
import $wOb1a$intlcolorelGRmjs from "../intl/color/el-GR.mjs";
import $wOb1a$intlcolorenUSmjs from "../intl/color/en-US.mjs";
import $wOb1a$intlcoloresESmjs from "../intl/color/es-ES.mjs";
import $wOb1a$intlcoloretEEmjs from "../intl/color/et-EE.mjs";
import $wOb1a$intlcolorfiFImjs from "../intl/color/fi-FI.mjs";
import $wOb1a$intlcolorfrFRmjs from "../intl/color/fr-FR.mjs";
import $wOb1a$intlcolorheILmjs from "../intl/color/he-IL.mjs";
import $wOb1a$intlcolorhrHRmjs from "../intl/color/hr-HR.mjs";
import $wOb1a$intlcolorhuHUmjs from "../intl/color/hu-HU.mjs";
import $wOb1a$intlcoloritITmjs from "../intl/color/it-IT.mjs";
import $wOb1a$intlcolorjaJPmjs from "../intl/color/ja-JP.mjs";
import $wOb1a$intlcolorkoKRmjs from "../intl/color/ko-KR.mjs";
import $wOb1a$intlcolorltLTmjs from "../intl/color/lt-LT.mjs";
import $wOb1a$intlcolorlvLVmjs from "../intl/color/lv-LV.mjs";
import $wOb1a$intlcolornbNOmjs from "../intl/color/nb-NO.mjs";
import $wOb1a$intlcolornlNLmjs from "../intl/color/nl-NL.mjs";
import $wOb1a$intlcolorplPLmjs from "../intl/color/pl-PL.mjs";
import $wOb1a$intlcolorptBRmjs from "../intl/color/pt-BR.mjs";
import $wOb1a$intlcolorptPTmjs from "../intl/color/pt-PT.mjs";
import $wOb1a$intlcolorroROmjs from "../intl/color/ro-RO.mjs";
import $wOb1a$intlcolorruRUmjs from "../intl/color/ru-RU.mjs";
import $wOb1a$intlcolorskSKmjs from "../intl/color/sk-SK.mjs";
import $wOb1a$intlcolorslSImjs from "../intl/color/sl-SI.mjs";
import $wOb1a$intlcolorsrSPmjs from "../intl/color/sr-SP.mjs";
import $wOb1a$intlcolorsvSEmjs from "../intl/color/sv-SE.mjs";
import $wOb1a$intlcolortrTRmjs from "../intl/color/tr-TR.mjs";
import $wOb1a$intlcolorukUAmjs from "../intl/color/uk-UA.mjs";
import $wOb1a$intlcolorzhCNmjs from "../intl/color/zh-CN.mjs";
import $wOb1a$intlcolorzhTWmjs from "../intl/color/zh-TW.mjs";

var $786ce78c8ff38b91$exports = {};


































$786ce78c8ff38b91$exports = {
    "ar-AE": $wOb1a$intlcolorarAEmjs,
    "bg-BG": $wOb1a$intlcolorbgBGmjs,
    "cs-CZ": $wOb1a$intlcolorcsCZmjs,
    "da-DK": $wOb1a$intlcolordaDKmjs,
    "de-DE": $wOb1a$intlcolordeDEmjs,
    "el-GR": $wOb1a$intlcolorelGRmjs,
    "en-US": $wOb1a$intlcolorenUSmjs,
    "es-ES": $wOb1a$intlcoloresESmjs,
    "et-EE": $wOb1a$intlcoloretEEmjs,
    "fi-FI": $wOb1a$intlcolorfiFImjs,
    "fr-FR": $wOb1a$intlcolorfrFRmjs,
    "he-IL": $wOb1a$intlcolorheILmjs,
    "hr-HR": $wOb1a$intlcolorhrHRmjs,
    "hu-HU": $wOb1a$intlcolorhuHUmjs,
    "it-IT": $wOb1a$intlcoloritITmjs,
    "ja-JP": $wOb1a$intlcolorjaJPmjs,
    "ko-KR": $wOb1a$intlcolorkoKRmjs,
    "lt-LT": $wOb1a$intlcolorltLTmjs,
    "lv-LV": $wOb1a$intlcolorlvLVmjs,
    "nb-NO": $wOb1a$intlcolornbNOmjs,
    "nl-NL": $wOb1a$intlcolornlNLmjs,
    "pl-PL": $wOb1a$intlcolorplPLmjs,
    "pt-BR": $wOb1a$intlcolorptBRmjs,
    "pt-PT": $wOb1a$intlcolorptPTmjs,
    "ro-RO": $wOb1a$intlcolorroROmjs,
    "ru-RU": $wOb1a$intlcolorruRUmjs,
    "sk-SK": $wOb1a$intlcolorskSKmjs,
    "sl-SI": $wOb1a$intlcolorslSImjs,
    "sr-SP": $wOb1a$intlcolorsrSPmjs,
    "sv-SE": $wOb1a$intlcolorsvSEmjs,
    "tr-TR": $wOb1a$intlcolortrTRmjs,
    "uk-UA": $wOb1a$intlcolorukUAmjs,
    "zh-CN": $wOb1a$intlcolorzhCNmjs,
    "zh-TW": $wOb1a$intlcolorzhTWmjs
};


export {$786ce78c8ff38b91$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
